import { typographyStyles, tokens, makeStyles } from '@fluentui/react-components';

export const useLoadingIndicatorStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '32px',
    ...typographyStyles.caption1Strong,
    color: tokens.colorNeutralForegroundDisabled,
  },
});
